import { ReactElement } from "react";
import './alert.scss';

interface IAlertProps {
    icon: ReactElement;
    title: string;
    body: ReactElement;
}

export default function Alert(props: IAlertProps) {
    return (
        <div className='alert'>
            <div className='alert__icon'>{props.icon}</div>
            <h2 className='alert__header'>{props.title}</h2>
            <div className='alert__text'>{props.body}</div>
        </div>
    );
};
